import { cn } from '@/lib/cn';

export const BUSINESS_WORKSPACE_TABS = [
  { id: 'overview', label: 'Overview' },
  { id: 'branches', label: 'Branches' },
  { id: 'access', label: 'Access & API' },
  { id: 'pos-operation', label: 'POS Operation' },
  { id: 'pos-access', label: 'POS Access' },
  { id: 'license', label: 'License' },
  { id: 'updates', label: 'Updates' },
  { id: 'owner', label: 'Owner' },
  { id: 'sync', label: 'Sync' },
  { id: 'inventory', label: 'Inventory' },
  { id: 'activity', label: 'Activity' },
] as const;

export type BusinessWorkspaceTab = (typeof BUSINESS_WORKSPACE_TABS)[number]['id'];

export function BusinessWorkspaceNav({
  active,
  onChange,
  hiddenTabs,
}: {
  active: BusinessWorkspaceTab;
  onChange: (tab: BusinessWorkspaceTab) => void;
  hiddenTabs?: readonly BusinessWorkspaceTab[];
}) {
  const hidden = new Set(hiddenTabs ?? []);
  return (
    <nav aria-label="Business workspace" className="mb-6 border-b border-line">
      <ul className="-mb-px flex gap-0.5 overflow-x-auto">
        {BUSINESS_WORKSPACE_TABS.filter((t) => !hidden.has(t.id)).map((tab) => {
          const selected = active === tab.id;
          return (
            <li key={tab.id}>
              <button
                type="button"
                role="tab"
                aria-selected={selected}
                onClick={() => onChange(tab.id)}
                className={cn(
                  'whitespace-nowrap border-b-2 px-3 py-2.5 text-[13px] font-medium transition-colors focus-visible:shadow-focus focus-visible:outline-none',
                  selected
                    ? 'border-primary text-primary'
                    : 'border-transparent text-ink-secondary hover:border-line-strong hover:text-ink',
                )}
              >
                {tab.label}
              </button>
            </li>
          );
        })}
      </ul>
    </nav>
  );
}
